// @core/api/endpoints/secret/sign_intermediate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CertificateResponse,
  SignIntermediateRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Sign intermediate CSR
 * Signs an intermediate CA CSR using the root CA, producing a signed intermediate certificate. The intermediate can then issue leaf certificates.
 */
export async function SignIntermediate(
  engine_id: string,
  data: SignIntermediateRequest,
  options?: RequestOptions
): Promise<CertificateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/intermediate/sign`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<CertificateResponse>(requestPath, data, requestOptions);
}
